export const formatMoney = (value) => {
  const num = Number(value || 0);
  return num.toLocaleString("en-NZ", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};
